import styles from "./Time.module.css";
import { denormalizeDate, isDateFarEnough } from "../../../utils/calendar";
import { getDayHours, isAvailableOn, WEEK_DAY_FULL } from "../../../utils/calendar";
import { DayKey } from "../../../types/product.types";
import { TimeEditTarget } from "../../../context/TimeModalContext";
import { CartItem } from "../../../types/cart.types";
import { getAdvanceDays } from "../../../utils/products";

type TimeDatePickerProps = {
    selectedDate: string;
    setSelectedDate: (date: string) => void;
    dateOptionsISO: string[];
    dateOpen: boolean;
    setDateOpen: React.Dispatch<React.SetStateAction<boolean>>;
    dateRef: React.RefObject<HTMLDivElement | null>;
    timeTarget: TimeEditTarget;
    allProducts: any[];
    groupItems: CartItem[];
    setSelectOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const TimeDatePicker = ({
    selectedDate,
    setSelectedDate,
    dateOptionsISO,
    dateOpen,
    setDateOpen,
    dateRef,
    timeTarget,
    allProducts,
    groupItems,
    setSelectOpen,
}: TimeDatePickerProps) => {
    const passesLeadTime = (advance: number | undefined, date: string) =>
        (advance && isDateFarEnough(advance, date)) || advance === 0;

    const passesSingleDate = (date: string) => {
        if (!passesLeadTime(timeTarget.advance, date)) return false;

        if (timeTarget.prodType === "sales") {
            const product = allProducts?.find((p) => p.id === timeTarget.productId);
            if (product) {
                const { day } = getDayHours(date);
                const weekday = WEEK_DAY_FULL[day - 1] as DayKey;
                if (!isAvailableOn(product, weekday)) return false;
            }
        }

        return true;
    };

    const passesGroupDate = (date: string) => {
        return groupItems.every((item) => {
            const product = allProducts?.find((p: any) => p.id === item.id);
            if (!product) return true;

            const { day } = getDayHours(date);
            const weekday = WEEK_DAY_FULL[day - 1] as DayKey;
            if (!isAvailableOn(product, weekday)) return false;

            if (product.order_in_advance) {
                const adv = getAdvanceDays(product, 0);
                if (adv > 0 && !isDateFarEnough(adv, date)) return false;
            }

            return true;
        });
    };

    const isStatic = timeTarget.static === true;
    const isGroup = timeTarget.type === "group" && !isStatic;

    return (
        <div className={styles.DatePickWrapper} ref={dateRef}>
            <div
                className={styles.DatePick}
                onClick={() => setDateOpen((prev) => !prev)}
            >
                {selectedDate && <p>{denormalizeDate(selectedDate)}</p>}
            </div>
            {dateOpen === true && (
                <div className={styles.PossibleDates}>
                    {dateOptionsISO.map((date, index) => {
                        const ok = isGroup ? passesGroupDate(date) : passesSingleDate(date);
                        if (!ok) return null;

                        const handleClick = () => {
                            if (isStatic) return;
                            setSelectedDate(date);
                            setSelectOpen(false);
                        };

                        return (
                            <div
                                className={`${styles.DateOption} ${
                                    selectedDate === date ? styles.SelectedDate : ""
                                }`}
                                key={`${date}-${index}`}
                                onClick={isStatic ? undefined : handleClick}
                            >
                                <p>{denormalizeDate(date)}</p>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default TimeDatePicker;
